import React, { useCallback } from 'react';
import QuickPinchZoom from 'react-quick-pinch-zoom';

const NonZoomableContainer = ({ children }) => {
  const handleUpdate = useCallback(() => {
    // Do nothing
  }, []);

  return <QuickPinchZoom onUpdate={handleUpdate}>{children}</QuickPinchZoom>;
};

export default NonZoomableContainer;
